import PullupModal from '@map/components/layout/PullupModal';
import { makeStyles } from '@map/theme';
import { CircularProgress, Grid, Typography } from '@mui/material';
import Button from '@ui/Button';
import NavButton from '@ui/NavButton';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import ModalDialog from './ModalDialog';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    padding: spacing(9),
  },
  buttons: {
    marginTop: spacing(5),
    '& > *': {
      margin: spacing(0, 1.5),
    },
  },
}));

type Props = {
  open: boolean;
  variant?: 'pullup' | 'centered';
  busy?: boolean;
  title?: ReactNode;
  text?: ReactNode;
  confirmLabel?: ReactNode;
  confirmButtonVariant?: 'danger';
  cancelLabel?: ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  reverseButtons?: boolean;
  closeOnBackdrop?: boolean;
};
const ConfirmModal = ({
  open,
  busy,
  title,
  text,
  confirmLabel,
  cancelLabel,
  confirmButtonVariant,
  onConfirm,
  reverseButtons,
  onCancel,
  closeOnBackdrop = true,
  variant = 'pullup',
}: Props) => {
  const { classes } = useStyles();
  const buttonsElements = [
    <Button key="cancel" variant="secondary" onClick={onCancel}>
      {cancelLabel || <FormattedMessage id="common.choose_no" />}
    </Button>,
    <NavButton
      key="confirm"
      color={confirmButtonVariant === 'danger' ? 'error' : undefined}
      onClick={onConfirm}
    >
      {confirmLabel || <FormattedMessage id="common.choose_yes" />}
    </NavButton>,
  ];
  const buttons = reverseButtons ? buttonsElements.reverse() : buttonsElements;

  return variant === 'pullup' ? (
    <PullupModal
      className={classes.root}
      open={open}
      onClose={onCancel}
      closeOnBackdrop={closeOnBackdrop}
    >
      <Typography variant="subtitle1" gutterBottom>
        {title || <FormattedMessage id="common.confirm_action" />}
      </Typography>
      {text && (
        <Typography variant="body2" color="textSecondary" align="center">
          {text}
        </Typography>
      )}
      <Grid className={classes.buttons} container justifyContent="center">
        {busy ? <CircularProgress /> : buttons}
      </Grid>
    </PullupModal>
  ) : (
    <ModalDialog
      open={open}
      title={title || <FormattedMessage id="common.confirm_action" />}
      text={text}
      actionButtons={buttons}
      onClose={onCancel}
    />
  );
};

export default ConfirmModal;
